export const faq = [
    {
        question:"Is there a quantity limit for orders?",
        answer:"No, there is no minimum or maximum or limit for orders. If you wish to place a bulk order, please contact us for bulk pricing."
    },
    {
        question:"How can I place an order?",
        answer:"You can place an order through our website. To place an order offline, you can reach out to us either on Whatsapp or over a phone call."
    },
    {
        question:"Can I modify my order details upon order confirmation?",
        answer:"We can help modify customer and shipping details. However, if the order has been shipped, we will be unable to make any changes."
    },
    {
        question:"How can I track my order?",
        answer:"You will receive regular updates on your registered email address, with accurate shipping details regarding your order. Alternatively you can track your order status on the ‘My account’ section on our website."
    },
    {
        question:"Can i cancel my order?",
        answer:"No, unfortunately we are unable to cancel an order once it has been placed."
    },
    {
        question:"Do you offer any discount?",
        answer:"We offer different pricing for bulk orders, please contact us for more information"
    },
    {
        question:"Do you ship worldwide?",
        answer:"Yes, we ship to over 100+ countries."
    },
    {
        question:"What is the cost of Shipping?",
        answer:"The stated prices of the miners are inclusive of shipping costs. There are no extra costs for shipping."
    },
    {
        question:"How long will it take you to ship out orders?",
        answer:"Orders are shipped out within 48 hours of order confirmation."
    },
    // {
    //     question:"Is there a quantity limit for orders?",
    //     answer:"Each product is crafted to optimize efficiency, enhance sustainability, and support fair trade practices across the globe."
    // },
] 